import { Loader } from 'lucide-react';
import { Container } from './ComponentPreloader.styles';

interface ComponentPreloaderProps {
  width?: string;
  height?: string;
  minWidth?: string;
  maxWidth?: string;
  minHeight?: string;
  maxHeight?: string;
  sx?: any;
}

const ComponentPreloader = ({
  width = '300px',
  height = '150px',
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  sx,
}: ComponentPreloaderProps) => {
  return (
    <Container
      width={width}
      height={height}
      minWidth={minWidth}
      maxWidth={maxWidth}
      minHeight={minHeight}
      maxHeight={maxHeight}
      style={sx}
    >
      <div className="text-sm text-text-200 mt-4 flex items-center gap-2">
        <Loader className="animate-spin" />
        Loading...
      </div>
    </Container>
  );
};

export default ComponentPreloader;
